import React, { FC, useContext, useEffect, useMemo } from 'react';
import {
    BirthdayField,
    BirthPlaceField,
    FullNameField,
    PassportDateField,
    PassportIssuedByField,
    PassportNumberField,
    UnitCodeField,
} from './fields';
import { useFormContext } from 'react-hook-form';
import { FORM_FIELDS, FORM_STEPS } from '../../../../../constants';
import { SheetContent, SheetFooter, SheetHeader } from '../../components/form/components/focused.sheet';
import { StepContext } from '../../../creator/step.context';

export const PassportStepSheetView: FC = React.memo(() => {
    const form = useFormContext();
    const { currentStepConfig, currentStep, setFocusedField, focusedField } = useContext(StepContext);
    const {
        formState: { dirtyFields: _ },
    } = form;

    useEffect(() => {
        if (currentStepConfig.stepName === FORM_STEPS.PASSPORT && focusedField) {
            setFocusedField(FORM_FIELDS.FULL_NAME);
        }
    }, [currentStep]);

    const fieldsList = useMemo(() => {
        return [
            { name: FORM_FIELDS.FULL_NAME, view: FullNameField },
            { name: FORM_FIELDS.BIRTHDAY, view: BirthdayField },
            { name: FORM_FIELDS.BIRTH_PLACE, view: BirthPlaceField },
            { name: FORM_FIELDS.PASSPORT_NUMBER, view: PassportNumberField },
            { name: FORM_FIELDS.PASSPORT_DATE, view: PassportDateField },
            { name: FORM_FIELDS.UNIT_CODE, view: UnitCodeField },
            { name: FORM_FIELDS.ISSUED, view: PassportIssuedByField },
        ];
    }, []);

    return (
        <>
            <SheetHeader />
            <SheetContent fieldsList={fieldsList} />
            <SheetFooter fieldsList={fieldsList} />
        </>
    );
});

PassportStepSheetView.displayName = 'PassportStepSheetView';
